import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron"]

  connect() {
    // Auto-expand and scroll to this row if the URL hash targets it
    if (window.location.hash === `#${this.element.id}`) {
      this.expand()
      // Delay scroll to ensure layout is settled
      requestAnimationFrame(() => {
        this.element.scrollIntoView({ behavior: "smooth", block: "start" })
      })
    }
  }

  toggle(event) {
    // Don't toggle if clicking the drag handle or a form element inside the header
    if (event.target.closest(".sortable-handle") ||
        event.target.closest("button[type='button'][role='switch']") ||
        event.target.closest("input") ||
        event.target.closest("select") ||
        event.target.closest("a")) {
      return
    }

    const isExpanded = !this.contentTarget.classList.contains("hidden")

    if (isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.contentTarget.classList.remove("hidden")
    this.chevronTarget.classList.add("rotate-90")
  }

  collapse() {
    this.contentTarget.classList.add("hidden")
    this.chevronTarget.classList.remove("rotate-90")
  }
}
